import styled from '@emotion/styled'
import { BREAKPOINTS } from 'utils/styled'

export const SFutureMessageHeroContentWrapper = styled.div`
  margin: 0 var(--p-content);
  position: relative;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media ${BREAKPOINTS.MD.max} {
    margin-top: 1rem;
    margin-bottom: 2rem;
    flex-direction: column;
  }
`

export const SFutureMessageHeroContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 45%;
  position: relative;

  @media ${BREAKPOINTS.MD.max} {
    width: 100%;
    order: 1;
  }
`

export const SFutureMessageHeroContentBox = styled.div`
  position: relative;
  padding: 43px 56px 43px 0;
  margin-top: 2rem;
  margin-bottom: 2rem;

  &:before {
    content: '';
    border: 2px solid var(--c-blue100);
    position: absolute;
    z-index: -1;
    top: 0;
    left: var(--p-button);
    right: min(-19px, calc(-1 * var(--space-width)));
    bottom: 0;
    max-width: 100%;
    box-sizing: content-box;
  }

  @media ${BREAKPOINTS.LG.max} {
    padding: 20px 10px 20px 0;
  }

  @media ${BREAKPOINTS.MD.max} {
    margin-top: 0;
    margin-bottom: 0;
    padding: 0 0 20px 0;

    &:before {
      top: -1rem;
      bottom: -30%;
    }
  }
`

export const SFutureMessageHeroGallery = styled.div`
  right: 0;
  top: 0;
  width: 47%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  & > div {
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    object-position: center 15%;
  }

  @media ${BREAKPOINTS.MD.max} {
    order: 2;
    width: 100%;
    margin-bottom: 1rem;
  }
`
